import React from 'react';
import { MenuItem } from '@mui/material';
import { translate } from 'translations/translator';
const getTranslation = key => translate('lessonPlanner', key);

type Props = {
  handleViewAssignments: () => void;
  handleEditAssignments: () => void;
  handleUnassign: () => void;
};

export const AssignmentsMenu: React.FC<Props> = ({
  handleEditAssignments,
  handleUnassign,
  handleViewAssignments
}) => {
  return (
    <>
      <MenuItem onClick={handleViewAssignments}>{getTranslation('viewAssignments')}</MenuItem>
      <MenuItem onClick={handleEditAssignments}>{getTranslation('editAssignments')}</MenuItem>
      <MenuItem onClick={handleUnassign}>{getTranslation('unassign')}</MenuItem>
    </>
  );
};
